"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByteArraySchema = exports.ArraySchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class ArraySchema extends schema_1.Schema {
    constructor(name, description, elementType, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Array);
        this.elementType = elementType;
        this.apply(objectInitializer);
    }
}
exports.ArraySchema = ArraySchema;
class ByteArraySchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.ByteArray);
        this.apply(objectInitializer);
    }
}
exports.ByteArraySchema = ByteArraySchema;
//# sourceMappingURL=array.js.map